import React from 'react';
import withRouter from '../../../App/components/withRouter';
import Aux from "../../../hoc/_Aux";
import { connect } from 'react-redux'
import queryString from 'query-string';
import { GET_PROGRAM_DATA } from '../../../store/actions/dashboardAction';
import { GET_CLIENT_TERMS, GET_DEFAULT_CULTURE } from '../../../store/actions/termsPrivacy';
import { getLang } from '../../../helper/utils';
import { withTranslation } from 'react-i18next';
import { getJsonLanguage } from '../../../helper/i18next-utils';
import { PORTAL_INSTANCE } from '../../..';
import RegisterForm from './RegisterForm3';


const mapStateToProps = state => {
    return {
        authLoginError: state.auth.authLoginError,
        authErrorCode: state.auth.authErrorCode,
        portalsSameUser: state.auth.portalsSameUser,
        selectedPortalLogo: state.portal.selectedPortalLogo,
        programData: state.allRequest.programData,
        qrCode: state.auth.qrCode,
        userLocationDetails: state.dateFormat.userLocationDetails,
        countryUOM: state.dateFormat.countryUOM,
        termsPrivacy: state.termsPrivacy.termsPrivacyDetail,
        userGroup: state.user.userGroup || [],
        programCulturesList: state.homeCustomer.programCulturesList,
        allProgramLanguages: state.newRequest.allProgramLanguages,
        portalUserCompanies: state.newRequest.portalUserCompanies,
    }
}

const mapDispatchToProps = {
    GET_PROGRAM_DATA: (payload) => GET_PROGRAM_DATA(payload),
    GET_CLIENT_TERMS: (payload) => GET_CLIENT_TERMS(payload),
    GET_DEFAULT_CULTURE: (payload) => GET_DEFAULT_CULTURE(payload),
}

class RegisterForm2 extends React.Component {
    constructor(props) {
        super(props);
        let { cId, pId } = PORTAL_INSTANCE
        const query = new URLSearchParams(this.props.location.search);
        this.state = {
            portalId: pId,
            clientId: cId,
            password: '',
            forgotUserNameEmail: '', // email
            acceptTerms: false,
            rememberMe: false,

            error: '',

            showChangePwd: false,
            showRegisterForm: false,
            // defaultCulture: null,
        }
    }

    params = queryString.parse(this.props.location.search)

    async componentDidMount() {

        let localLang = getLang(this.state.portalId)

        // const cultureInfo = await this.props.GET_DEFAULT_CULTURE({ portalId: this.state.portalId });
        // if (cultureInfo && cultureInfo.shortCut) {
        //     localLang = cultureInfo.shortCut
        //     this.setState({ defaultCulture: cultureInfo});
        // }
        getJsonLanguage(localLang, this.state.portalId)

        this.props.GET_CLIENT_TERMS({ clientId: this.state.clientId, portalId: this.state.portalId })
        if (!this.props.programData || !Object.keys(this.props.programData).length) {
            await this.props.GET_PROGRAM_DATA({ portalId: this.state.portalId, clientId: this.state.clientId });
        }
    }

    onChangeInput = (event) => {
        this.setState({
            error: '',
            portalsSameUser: [],
            selectedPortalId: '',
        })
        let { name, value } = event.target
        if (event.target.type == 'checkbox') value = event.target.checked;

        this.setState({
            [name]: value
        }, () => { this.onValidateAccount() })
    }

    onValidateAccount = () => {
        const { t, } = this.props
        const { username, password, } = this.state
        let error = ''
        if (!username || username.trim().length === 0) {
            error = t('MsgErrorUsername')
        } else if (username.length < 2) {
            error = t('MsgErrorMinimum2Char')
        } else if (!password || password.trim().length === 0) {
            error = t('MsgErrorPassword')
        }

        this.setState({ error })
        if (error) {
            // toast.warn(error)
            return false
        }
        return true
    }

    onEnter = (e) => {
        if (e.keyCode === 13) {
            this.onLogInUser()
        }
    }

    selectPortal = (portalE) => {
        const found = this.state.portalsSameUser.find(e => e.portalId === portalE.value);
        if (found && found.portalId && found.clientId) {
            this.setState({
                selectedClientId: found.clientId,
                selectedPortalId: found.portalId
            })
        }
    }

    onReloadPage() {
        window.location.reload()
    }

    render() {
        return (
            <Aux>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col-md-12 col-lg-4">
                        <div className="login-header">
                            {/* <img width={'4.688rem'} src={portalLogoUrl()} />
                            <span className="splitter"></span>
                            <span className="title">Customer Portal</span> */}
                        </div>
                        <div className="row">
                   
                        </div>
                    </div>
                    <div className="col-lg-8 d-none d-md-none d-lg-block" style={{ padding: 0 }}>
                        {/* <div className="login-bg">
                            <img src="/theme/img/portal-signinbg.jpg" />
                        </div> */}
                    </div>
                </div>

                <div className='registration'>
                    { this.props.programData.id ? <RegisterForm id={'register-form'} 
                        portalId={this.state.portalId} 
                        clientId={this.state.clientId} 
                        programData={this.props.programData} 
                        onHide={() => { this.setState({ showRegisterForm: false }) }} 
                        programCulturesList={this.props.programCulturesList} 
                        termsPrivacy={this.props.termsPrivacy}
                        allProgramLanguages={this.props.allProgramLanguages}
                        defaultCulture={this.state.defaultCulture}></RegisterForm> : null}
                </div>

            </Aux >
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RegisterForm2)));